import { gql } from '@apollo/client';

export default gql`
  mutation startPositioningSession($bracelets: [String!]!) {
    startPositioningSession(bracelets: $bracelets)
  }
`;
